"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _utilityClassNames = require("@wel-ui/utility-class-names");

var _utilityClassNames2 = _interopRequireDefault(_utilityClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function (_Component) {
  (0, _inherits3.default)(Button, _Component);

  function Button(props) {
    (0, _classCallCheck3.default)(this, Button);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).call(this, props));

    _this.getClassName = (0, _utilityClassNames2.default)(Button.displayName);
    return _this;
  }

  (0, _createClass3.default)(Button, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          active = _props.active,
          block = _props.block,
          children = _props.children,
          color = _props.color,
          disabled = _props.disabled,
          href = _props.href,
          icon = _props.icon,
          kind = _props.kind,
          onClick = _props.onClick;


      var buttonProps = {
        className: this.getClassName({
          modifiers: (0, _classnames2.default)(color, block ? "block" : null),
          states: (0, _classnames2.default)({
            active: active,
            disabled: disabled
          })
        }),
        onClick: onClick
      };

      var bodyProps = {
        className: this.getClassName({ descendantName: "body" })
      };

      var iconProps = {
        className: this.getClassName({ descendantName: "icon" })
      };

      var element = void 0;

      if (kind === "link") {
        element = _react2.default.createElement(
          "a",
          (0, _extends3.default)({}, buttonProps, { href: href }),
          _react2.default.createElement(
            "span",
            bodyProps,
            children
          ),
          icon && _react2.default.createElement(
            "span",
            iconProps,
            icon
          )
        );
      } else {
        element = _react2.default.createElement(
          "button",
          (0, _extends3.default)({}, buttonProps, { disabled: disabled, type: kind }),
          _react2.default.createElement(
            "span",
            bodyProps,
            children
          ),
          icon && _react2.default.createElement(
            "span",
            iconProps,
            icon
          )
        );
      }

      return element;
    }
  }]);
  return Button;
}(_react.Component);

Button.displayName = "Button";
Button.propTypes = {
  active: _propTypes2.default.bool,
  block: _propTypes2.default.bool,
  children: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.oneOf(["primary", "secondary"]).isRequired,
  disabled: _propTypes2.default.bool,
  href: _propTypes2.default.string,
  icon: _propTypes2.default.node,
  kind: _propTypes2.default.oneOf(["button", "link", "submit"]).isRequired,
  onClick: _propTypes2.default.func
};
exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/component-button/lib/Button.js
// module id = 284
// module chunks = 0